// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2751":"3a780220","3648":"48484966","7759":"3a780220"}[chunkId] + ".chunk.css";
};